import * as ActionType from '../../constants/actionType';

const initialState = {};
export default function availableLabwareStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.ADD_AVAILABLE_LABWARE:
      return {...state, [action.labware.labwareID]: action.labware};
    case ActionType.ADD_INITIAL_LABWARE:
      return {...action.labware};
    case ActionType.SET_RECENT_LABWARE:
      return {...state, [action.labwareId]: {...state[action.labwareId], recentlyAdded: true}};
    case ActionType.RESTORE_AVAILABLELABWARESTATE:
      return action.state;
    case ActionType.RESET_AVAILABLELABWARESTATE:
      return initialState;
    default:
      return state;
  }
}
